module.exports = __webpack_public_path__ + "static/media/paymentQR.b15985d0.png";